module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/timer-56e277bf253292c45ce64a39e6ca236a.svg";